import { Divider as AntDivider } from 'antd';
import { FC, ReactNode } from 'react';

interface IDividerProps {
  className?: string;
  children?: ReactNode;
  dashed?: boolean;
  orientation?: 'left' | 'right' | 'center';
  type?: 'horizontal' | 'vertical';
}

export const Divider: FC<IDividerProps> = ({ className, ...props }) => {
  return <AntDivider className={className} style={{ borderColor: 'rgba(0, 0, 0, 0.12)' }} {...props} />;
};
